module.exports = __webpack_public_path__ + "img/enlarge-image.5fb6f038.svg";